import {useTranslation} from 'react-i18next';
import {HtmlContent} from '@client/utils/html_content';
import minimumLabel from '../../../img/product/minimum.png';
import mieuxLabel from '../../../img/product/mieux.png';
import idealLabel from '../../../img/product/ideal.png';
import eviterLabel from '../../../img/product/eviter.png';

const LABEL_IMAGES = {
    'minimum': minimumLabel,
    'mieux': mieuxLabel,
    'idéal': idealLabel,
    'ideal': idealLabel,
    'éviter': eviterLabel,
    'eviter': eviterLabel,
};

const EpiTable = ({data}) => {
    const {t} = useTranslation();
    const renderLabelBadge = (label) => {
        if (!label) return null;

        const labelKey = label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const labelImage = LABEL_IMAGES[labelKey] || LABEL_IMAGES[label.toLowerCase()];

        if (labelImage) {
            return (
                <img
                    src={labelImage}
                    alt={label}
                    className="h-6 object-contain"
                />
            );
        }

        return <div className="text-xs font-medium text-gray-700">{label}</div>;
    };

    const renderEpiImage = (imageData) => {
        if (!imageData) return null;

    return (
      <div className="flex flex-col items-center gap-1">
        <div className="flex items-start">
          {renderLabelBadge(imageData.label)}
        </div>
        <img
          src={imageData.src}
          alt={imageData.alt}
          className="w-12 h-12 sm:w-16 sm:h-16 object-contain rounded-lg"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <span className="hidden text-xs text-center text-gray-600">
          {imageData.alt}
        </span>
                {imageData.comments && (
                    <div className="mt-2 text-xs text-center max-w-[80px]">
                        <HtmlContent html={imageData.comments} className="text-[#000] text-center"/>
                    </div>
                )}
            </div>
        );
    };

    const renderEpiImages = (item) => {
        const images = [item.minimum, item.recommended, item.optimal].filter(Boolean);

        if (images.length === 0) {
            return <div className="text-center text-gray-400">-</div>;
        }

        return (
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
                {images.map((imageData, index) => (
                    <div key={index}>
                        {renderEpiImage(imageData)}
                    </div>
                ))}
            </div>
        );
    };

    // C75: when there is no EPI data at all, render nothing (no empty table).
    if (!data || data.length === 0) {
        return null;
    }

    return (
        <div className="w-full bg-white mt-[32px] flex flex-col gap-[16px]">
            <div className="bg-[#E9F1D9] rounded-[16px] px-[24px] py-[24px] hidden sm:flex gap-[32px]">
                <span className="font-bold flex-1">{t('product-details|epiTable.exposureZone')}</span>
                <span className="font-bold flex-2">{t('product-details|epiTable.epiLabel')}</span>
                <span className="font-bold flex-2">{t('product-details|epiTable.details')}</span>
            </div>

            <div className="flex flex-col gap-4">
                {data.map((item, index) => (
                    <div
                        key={index}
                        className="bg-[#F5F5F5] gap-[32px] rounded-[16px] px-3 sm:px-6 py-4 sm:py-6 flex flex-col sm:flex-row sm:justify-between sm:items-center"
                    >
                        <div className="flex-1">
                            <div className="block sm:hidden font-bold text-gray-900 mb-1">
                                {t('product-details|epiTable.exposureZone')}
                            </div>
                            <div className="text-[#5B8C00] font-bold">
                                {item.type}
                            </div>
                        </div>

                        <div className="flex-2">
                            <div className="block sm:hidden font-bold text-gray-900 my-3">
                                {t('product-details|epiTable.epiLabel')}
                            </div>
                            {renderEpiImages(item)}
                        </div>

                        <div className="flex-2">
                            <div className="block sm:hidden font-bold text-gray-900 my-3">
                                {t('product-details|epiTable.details')}
                            </div>
                            <div className="font-semibold text-gray-900">
                                {(item.details || item.additionalSageRecommendation) ? (
                                    <div className="space-y-3">
                                        {item.details && (
                                            <div>
                                                <p className="font-medium text-gray-900 mb-1">
                                                    {t('product-details|epiTable.labelMention')}
                                                </p>
                                                <HtmlContent html={item.details} className="text-gray-700 font-normal"/>
                                            </div>
                                        )}
                                        {item.additionalSageRecommendation && (
                                            <div>
                                                <p className="font-medium text-gray-900 mb-1">
                                                    {t('product-details|epiTable.sageRecommendations')}
                                                </p>
                                                <HtmlContent html={item.additionalSageRecommendation}
                                                             className="text-gray-700 font-normal"/>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <span className="text-gray-400">-</span>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* C76: Notes 1 & 2 at the bottom of the table. */}
            <div className="flex flex-col gap-1 mt-2 text-[12px] text-gray-500">
                <p className="m-0">{t('product-details|epiTable.footnoteSage')}</p>
                <p className="m-0">{t('product-details|epiTable.footnoteLabel')}</p>
            </div>
        </div>
    );
};

export default EpiTable;
